import gql from 'graphql-tag';

export const query = gql`
  query RecommendedEvents($studentProfile: StudentProfile, $first: Int, $after: String) {
    recommendedCollegeEvents(studentProfile: $studentProfile, first: $first, after: $after) {
      totalCount
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
      edges {
        node {
          collegeEvent {
            id
          }
          recommended
          recommendedAudienceProfile {
            id
          }
        }
      }
    }
  }
`;

export default query;
